'use strict';

var $ = require('jquery');
var ChartFBCUsagePartDirective = function ChartFBCUsagePartDirective(Chart, chartFormatter) {
  return {
    template: require('../templates/chart-fbc-usage-part.html'),
    controller: 'ChartFBCUsagePartController',
    replace: true,
    scope: {
      chartData: '=',
      expandMap: '='
    },
    link: function link($scope, element) {
      var chartFormatters = {
        xAxisTickFormatter: chartFormatter.identity,
        yAxisTickFormatter: chartFormatter.humanReadable,
        tooltipFormatter: $scope.createTooltipFormatter()
      };
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, chartFormatters);
      var textMessage = element.find('.data-missing .text-message');
      $scope.renderChartDataPresent = function (data) {
        chart.render(data);
        $scope.$emit('reload-carousel');
      };
      $scope.setErrorMessage = function (data) {
        var caption = '';
        if (data === undefined) {
          caption = 'Error retrieving data';
        } else if (data.length === 0) {
          caption = 'No data to display';
        }
        textMessage.text(caption);
        if (!data || !data.length) {
          $scope.$emit('reload-carousel');
        }
      };
      $scope.$on('$destroy', function () {
        $('.' + chartFormatters.tooltipFormatter.cssClass).remove();
      });
    }
  };
};
ChartFBCUsagePartDirective.$inject = ['ChartFBCFactory', 'FormatterService'];
module.exports = ChartFBCUsagePartDirective;